import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
} from '@angular/core';
import { GridRow } from '@shared/models/grid/grid-row';

@Component({
  standalone: false,
  selector: 'gstar-prime-grid-accordion-button',
  templateUrl: './prime-grid-accordion-button.component.html',
  styleUrl: './prime-grid-accordion-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrimeGridAccordionButtonComponent<TData> implements OnInit {
  row = input.required<GridRow<TData>>();
  isExpandedByDefault = input<boolean>(false);

  ngOnInit(): void {
    this.row().isDisabledAccordionButton =
      (this.row().data as { isAccordionDisabled?: boolean })
        .isAccordionDisabled ?? false;
    this.row().isRowExpanded = this.row().isDisabledAccordionButton
      ? false
      : this.isExpandedByDefault();
  }

  toggleAccordion(): void {
    this.row().isRowExpanded = !this.row().isDisabledAccordionButton
      ? !this.row().isRowExpanded
      : false;
  }
}
